// user Actions;
import {SignIn, LogOut, ChangeUserInfo } from './userActions.js';

// control Actions
import {ChangeData, ChangeEdit, ChangeLayout, ChangeLayoutsList, ChangeEquipamentList, ChangeLoading, ChangeComand, ChangeModalCode,
    sendingCode, ChangeLastUpdate, ChangeModalComands, ChangeAlarms, ChangeModalAlarms, showDetails, ChangeCards, ChangeGraphData, ChangeTime,
    ChangeControlCities, ChangeControlCity, ChangeControlShowCaption } from './controlActions.js';

// Dashboard Equipamento Actions
import {ChangeEquipamentoCards, ChangeTotalCards, ChangeDays, ChangeDay, ChangeMonth, ListEquipamentos, ChangeCardsLoading, ChangeDaysLoading, 
    changeyear, ChangeMode, ChangeStatus, ChangeCity, ListCities, ChangeCardIcon, ChangeAutoplay, ChangeEquipment } from './dashboardEquipamentoActions.js'

// Dashboard Controle de Perdas Actions
import {ChangeLossControlCards, changeLossControlDonutData, changeLossControlDonutDataTotal, ChangeLossControlTotalCards, ChangeLossControlDays, ChangeLossControlDay, ChangeLossControlMonth,
     ChangeLossControlCardsLoading, ChangeLossControlAutoplay, ChangeLossControlDaysLoading, ChangeLossControlyear, ChangeLossControlStatus, ChangeLossControlMode } from './dashboardControlePerdasActions.js'

    // Dashboard Geral Actions
import {ChangedashCards, ChangedashTotalCards, ChangedashDays, ChangedashDay, ChangedashMonth, ChangedashCardsLoading, ChangedashDaysLoading, 
    changedashyear, changeDonutData, ChangeDashMode, changeStatus, changeTitle, ChangeDados, ChangeCardStatus} from './dashboardGeralActions.js'

// Map Actions
import { ChangeMapLoading, ChangeMapEquipment, ChangeMapData, ChangeMapState, ChangeButtonsMap, ChangeEquipamentDataList, ChangeMapShowCaption, ChangeCheckedTutorial } from './mapActions.js';

// Históric Actions
import { changeHistoricLoading, changeHistoricLoadingList, changeHistoricListData, changeHistoricGraphData, changeHistoricPagination, ChangeAnalysisData, ChangeAllData,
    ChangeListOperationMode, changeOnlyGraphsData, changeOnlyGraphsLoading, changeHistoricCity, changeHistoricCities, changeHistoricEquipamentList } from './historicActions.js'

// user Actions;
export { SignIn, LogOut, ChangeUserInfo };

// control Actions
export { ChangeData, ChangeEdit, ChangeLayout, ChangeLayoutsList, ChangeEquipamentList, ChangeLoading, ChangeComand, ChangeModalCode,
    sendingCode, ChangeLastUpdate, ChangeModalComands, ChangeAlarms, ChangeModalAlarms, showDetails, ChangeCards, ChangeGraphData, ChangeTime,
    ChangeControlCities, ChangeControlCity, ChangeControlShowCaption };

// Dashboard Equipamento Actions
export {ChangeEquipamentoCards, ChangeTotalCards, ChangeDays, ChangeDay, ChangeMonth, ListEquipamentos, ChangeCardsLoading, ChangeDaysLoading, 
    changeyear, ChangeMode, ChangeStatus, ChangeCity, ListCities, ChangeCardIcon, ChangeAutoplay, ChangeEquipment };

// Dashboard Controle Perdas Actions
export {ChangeLossControlCards, changeLossControlDonutData, changeLossControlDonutDataTotal, ChangeLossControlTotalCards, ChangeLossControlDays, ChangeLossControlDay, 
    ChangeLossControlMonth, ChangeLossControlCardsLoading, ChangeLossControlAutoplay, ChangeLossControlDaysLoading, ChangeLossControlyear, ChangeLossControlStatus, ChangeLossControlMode  };

// Dashboard Geral Actions
export {ChangedashCards, ChangedashTotalCards, ChangedashDays, ChangedashDay, ChangedashMonth, ChangedashCardsLoading, ChangedashDaysLoading, changedashyear, 
    changeDonutData, ChangeDashMode, changeStatus, changeTitle, ChangeDados, ChangeCardStatus};

// Map Actions;
export { ChangeMapLoading, ChangeMapEquipment, ChangeMapData, ChangeMapState, ChangeButtonsMap, ChangeEquipamentDataList, ChangeMapShowCaption, ChangeCheckedTutorial };

// Históric Actions
export { changeHistoricLoading, changeHistoricLoadingList, changeHistoricListData, changeHistoricGraphData, changeHistoricPagination, ChangeAnalysisData, ChangeAllData,
    ChangeListOperationMode, changeOnlyGraphsData, changeOnlyGraphsLoading, changeHistoricCity, changeHistoricCities, changeHistoricEquipamentList };

// Geral Actions
export function ChangeTextVisibility(TextVisibility){
    return{
        type: 'ChangeTextVisibility',
        info: "ChangeTextVisibility",
        payload: TextVisibility
    }
}

export function changeModal (modalName){
    return{
        type: 'changeModal',
        info: "changeModal",
        payload: {modalName: modalName}
    }
}

export function changePopup (popupName){
    return{
        type: 'changePopup',
        info: "changePopup",
        payload: {popupName: popupName}
    }
}

export function changeLoations (Locations){
    return{
        type: 'changeLoations',
        info: "changeLoations",
        payload: {Locations: Locations}
    }
}

export function changeLoationtypes (Types){
    return{
        type: 'changeLoationtypes',
        info: "changeLoationtypes",
        payload: {Types: Types}
    }
}

export function changeCargos(Cargos){
    return{
        type: 'changeCargos',
        info: "changeCargos",
        payload: {Cargos: Cargos}
    }
}

export function ChangeEquipament (Equipament){
    return{
        type: 'ChangeEquipament',
        info: "ChangeEquipament",
        payload: {Equipament: Equipament}
    }
}

